import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface AssignedSkillcodesConfig extends AxiosRequestConfig {
  method: 'GET';
  url: `/classes/${string}/assigned-skillcodes`;
  baseURL: string;
}

export interface AssignedSkillcodesResponse {
  assignedSkillcodes: number[];
  pendingSkillcodes: number[];
  nextTransitionAt: string | null;
}

/**
 * GET /vo/v1/classes/{id}/assigned-skillcodes
 */
export const assignedSkillcodes = (
  classId: string,
): AssignedSkillcodesConfig => {
  return {
    method: 'GET',
    url: `/classes/${classId}/assigned-skillcodes`,
    baseURL: BASE_API,
  } as const;
};
